'use client';

import React from 'react';

interface YoutubeProps {
  videoId: number;
  isMobile: boolean;
}

export default function Youtube({ videoId, isMobile }: YoutubeProps) {
  const embedSrc = `https://www.youtube.com/embed/${videoId}?rel=0`;

  return (
    <div className="flex justify-center">
      <iframe
        width={!isMobile ? '560' : '375'}
        height={!isMobile ? '315' : '180'}
        src={embedSrc}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
